import { TourService } from './../../Services/tour.service';
import { AuthService } from './../../Services/auth.service';
import { Component, OnInit } from '@angular/core';
import { IMyDpOptions, IMyMarkedDate, IMyDayLabels } from 'mydatepicker';
import Swal from 'sweetalert2';
import * as $ from 'jquery';

@Component({
  selector: 'app-tour-form',
  template: require('./tour-form.component.html'),
  styles: [require('./tour-form.component.css')]
})
export class TourFormComponent implements OnInit {
  tourlist: any[] = [];
  tour: any = {};
  leaveHour: number = 8;
  leaveHourMin: number = 0;

  selectedDate: any;

  myDatePickerOptions: IMyDpOptions = {
    todayBtnTxt: 'Vandaag',
    dateFormat: 'dd/mm/yyyy',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    markCurrentDay: true,
    height: '34px',
    width: '210px',
    alignSelectorRight: false,
    openSelectorTopOfInput: false,
    indicateInvalidDate: true,
    monthSelector: true,
    yearSelector: true,
    minYear: 1920,
    maxYear: 2200,
    componentDisabled: false,
    editableDateField:false,
    showClearDateBtn: true,
    showDecreaseDateBtn: false,
    showIncreaseDateBtn: false,
    showSelectorArrow: true,
    showInputField: true,
    openSelectorOnInputClick: false,
    disableHeaderButtons: true,
    showWeekNumbers: false,
    markDates: [],
    satHighlight: false,
    highlightDates: [],
    markWeekends: <IMyMarkedDate>{},
    monthLabels: {
        1: 'Januari',
        2: 'Februari',
        3: 'Maart',
        4: 'April',
        5: 'Mei',
        6: 'Juni',
        7: 'July',
        8: 'Augustus',
        9: 'September',
        10: 'Oktober',
        11: 'November',
        12: 'December'
    },
    dayLabels: <IMyDayLabels>{
      su: 'zo', mo: 'ma', tu: 'di', we: 'wo', th: 'do', fr: 'vr', sa: 'za'
    },
    allowDeselectDate: true,
    disableWeekdays: [],
    allowSelectionOnlyInCurrentMonth: true
  };

  constructor(private auth: AuthService,
    private tourservice: TourService) { }

  ngOnInit() {
    this.getEntireTourList()
  }

  saveTour() {
    var time = new Date(Date.UTC(0, 0, 0, this.leaveHour, this.leaveHourMin, 0, 0));
    // var time = new Date(0, 0, 0, this.leaveHour, this.leaveHourMin, 0, 0);
    this.tour.leaveHour = time.toISOString();
   
    this.tour.date = String(this.selectedDate.date.year)+"-"+String(this.selectedDate.date.month)+"-"+String(this.selectedDate.date.day)
    // console.log(this.tour);
    this.tourservice.create(this.tour).subscribe(x => {
      this.getEntireTourList();
    })    
  }

  deleteTour(id: number) {
    Swal.fire({
        title: 'Ben je zeker?',
        text: "Ben je zeker dat je dit wil verwijderen?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Jep',
        cancelButtonText: 'Nope'
      }).then((result) => {
        if (result.value) {
          this.tourservice.delete(id).subscribe(x => {
            this.getEntireTourList();
          })
        }
      });
  }

  editTour(id: number){
    this.tour = this.tourlist.find( t => t.id == id );

    var t = new Date(this.tour.leaveHour)
    this.leaveHour = t.getHours()
    this.leaveHourMin = t.getMinutes();
    
    var d = new Date(this.tour.date);
    this.selectedDate = {
      jsdate: d,
      date:{year: d.getFullYear(), month: d.getMonth() +1, day: d.getDate()}
    };    
    (<any>$('#tourModal')).modal();
  }


  private getEntireTourList() {
    var isAdmin =  this.auth.isInRole('admin')
    this.tourservice.getEntireTourCalendar(isAdmin).subscribe(x => {
      this.tourlist = x;
      // console.log(this.tourlist);
    })
  }

  private checkIfObjectIsEmpty(s:any){
    return Object.keys(s).length == 0;
  }

  AddTourClick(){
    this.clearTour()
  }

  private clearTour() {
    this.tour = {};
    var d = new Date();
    this.selectedDate = {
      jsdate: d,
      date:{year: d.getFullYear(), month: d.getMonth() +1, day: d.getDate()}
    };    
    this.leaveHour = 8;
    this.leaveHourMin = 0;

  }

  checkIfLinkIsLocal(s:string):number{
    var substring ='/courses/view/';
    var id:number = -1;
    if (s !=null){
      if (s.includes(substring)){
        id = +s.substring(s.indexOf(substring)+substring.length);
      }else{
        id = -1;
      }
    }
    return id;
  }

  MaximixeToggle(){
    // console.log("Maximize Toggle");
    
    var id = 'toMaximize'
    var classToAdd = 'fullscreen'
    var el = document.getElementById(id)

    if (el != null){

      if (el.classList.contains(classToAdd)){
        el.classList.remove(classToAdd);   
        
      }else{
        el.classList.add(classToAdd);

      }
    }


  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/tour-form/tour-form.component.ts